/*
 * A short fingerprint of a compose body. The backend reads the open body, edits it
 * (answers inside the quoted chain, tracked-change markup) and writes the whole body
 * back; the write carries the fingerprint of the body it edited, and the pane refuses
 * it when the body has changed since, so text the user typed meanwhile is never lost.
 */
export function bodySig(html: string | null | undefined): string {
  const s = html || "";
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return s.length + ":" + h.toString(16);
}
